import type { RouteObject } from 'react-router-dom'

import { Component as EmployeeList } from '@/modules/employerUsers/pages/EmployerUsers'
import { EmployerUsersRoutePathsEnum } from '@/modules/employerUsers/routes/employerUsersRouteConfig.types'

export const EMPLOYER_USERS_ROUTES: RouteObject[] = [
  {
    element: <EmployeeList />,
    path: EmployerUsersRoutePathsEnum.USERS,
  },
]
